<table datatable [dtOptions]="dtOptions" class="row-border hover w-100">
  <thead>
    <tr>
      <ng-container *ngFor="let itemTitle of itemsTitles; index as i">
        <th *ngIf="itemTitle !== 'Imprimir boleto'">{{ itemTitle }}</th>
      </ng-container>
      <th *ngIf="itemsTitles.length > 0">{{ "Ações" }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of items">
      <ng-container *ngFor="let itemCollumn of getVisibleAttributes(item)">
        <td>
          <div *ngIf="isLink(itemCollumn)" class="table-actions" style="display: flex; gap: 10px">
            <div *ngIf="hasHistory(item)">
              <a class="table-link"
                  (click)="history && openHistoricoBoletoModal(item)"
                  [ngClass]="{'disabled-link': !history}">
                <i
                  class="fa fa-history"
                  tooltip="HISTÓRICO DE BOLETOS Mostra todas as Ações de Dentro do Boleto"
                  style="font-size: 1.5em; color: #007bff"
                  data-toggle="modal"
                  data-target="#historicoBoletoModal"
                ></i>
              </a>
            </div>
            <div>
              <a *ngIf="canPrint(item, itemCollumn)" class="table-link" (click)="onClick(itemCollumn)">
                <i
                  class="fa fa-print"
                  tooltip="Imprimir Boleto"
                  style="font-size: 1.5em; color: #007bff"
                ></i>
              </a>
            </div>
            <div>
              <a *ngIf="hasPermission(item, itemCollumn) && canPrint(item, itemCollumn)" class="table-link" (click)="openProrrogacaoBoletoModal(item)">
                <i
                  class="fa fa-calendar-alt"
                  tooltip="Prorrogar Boleto"
                  style="font-size: 1.5em; color: #007bff"
                  data-toggle="modal"
                  data-target="#prorrogacaoBoletoModal"
                ></i>
              </a>
            </div>
            <div>
              <a *ngIf="hasPermission(item, itemCollumn) && canPrint(item, itemCollumn)" class="table-link" (click)="openAbatimentoBoletoModal(item)">
                <i
                  class="fa fa-dollar-sign"
                  tooltip="Abatimento de Boleto"
                  style="font-size: 1.5em; color: #007bff"
                  data-toggle="modal"
                  data-target="#abatimentoBoletoModal"
                ></i>
              </a>
            </div>
            <div>
              <a *ngIf="hasPermission(item, itemCollumn) && canPrint(item, itemCollumn)" class="table-link" (click)="openBaixaBoletoModal(item)">
                <i
                  class="fa fa-file-download"
                  tooltip="Baixa de Boleto"
                  style="font-size: 1.5em; color: #007bff"
                  data-toggle="modal"
                  data-target="#baixaBoletoModal"
                ></i>
              </a>
            </div>
          </div>
          <span *ngIf="!isLink(itemCollumn)"
                [ngStyle]="{
                    'background-color': getItemValue(itemCollumn) === 'Em aberto' ? '#007bff' :
                        (getItemValue(itemCollumn) === 'Liquidado' ? 'green' :
                        (getItemValue(itemCollumn) === 'Em atraso' ? 'red' :
                        (getItemValue(itemCollumn) === 'Em cartório' ? 'red' : 'transparent'))),
                  'color': getItemValue(itemCollumn) === 'Em aberto' || getItemValue(itemCollumn) === 'Em atraso' || getItemValue(itemCollumn) === 'Liquidado' || getItemValue(itemCollumn) === 'Em cartório' ? 'white' : 'inherit',
                  'padding': '5px',
                  'border-radius': '5px'
                }">
            {{ getItemValue(itemCollumn) }}
          </span>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>

<div class="modal fade" id="prorrogacaoBoletoModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="prorrogacaoBoletoModalLabel">
          Prorrogação de Boleto
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="documento" class="col-form-label">Documento:</label>
            <input type="text" class="form-control" id="documento" [(ngModel)]="documento" disabled />
        </div>
        <div class="form-group">
          <label for="valor" class="col-form-label">Valor do Boleto:</label>
          <input type="number" class="form-control" id="valor" step="0.01" [(ngModel)]="valor"  disabled />
        </div>
        <div class="form-group">
          <label for="data-vencimento" class="col-form-label">Vencimento:</label>
          <input type="date" class="form-control" id="data-vencimento" [(ngModel)]="dataVencimento" disabled  />
        </div>
        <form>
          <div class="form-group">
            <label for="nova-data" class="col-form-label"
              >Nova Data de Vencimento:</label
            >
            <input type="date" class="form-control" id="nova-data" #novaData required />
          </div>
          <div class="form-group">
            <label for="motivo" class="col-form-label">Motivo:</label>
            <textarea class="form-control" id="motivo" #motivoProrrogacao required tooltip="No mínimo 10 caractéres" ></textarea>
          </div>
        </form>
        <div class="alert alert-info" role="alert">
          Você receberá um e-mail com o retorno da sua solicitação.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onProrrogarBoleto(novaData.value, motivoProrrogacao.value, selectedItem)"
          [disabled]="!novaData.value || !motivoProrrogacao.value || motivoProrrogacao.value.length < 10"
        >
          Solicitar Prorrogação
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="abatimentoBoletoModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="abatimentoBoletoModalLabel">
          Abatimento de Boleto
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="documento" class="col-form-label">Documento:</label>
            <input type="text" class="form-control" id="documento" [(ngModel)]="documento"  disabled />
        </div>
        <div class="form-group">
          <label for="data-vencimento" class="col-form-label">Vencimento:</label>
          <input type="date" class="form-control" id="data-vencimento" [(ngModel)]="dataVencimento" disabled  />
        </div>
        <div class="form-group">
          <label for="valor" class="col-form-label">Valor do Boleto:</label>
          <input type="number" class="form-control" id="valor" step="0.01" [(ngModel)]="valor"  disabled />
        </div>
        <form>
          <div class="form-group">
            <label for="valor-abatimento" class="col-form-label"
              >Valor do Abatimento:</label>
            <input type="text"
              class="form-control"
              id="valor-abatimento"
              [mask]="getCurrencyMask()"
              (input)="onInputChangeValorAbatimento($event)"
              #valorAbatimento required />
          </div>
          <div class="form-group">
            <label for="motivo" class="col-form-label">Motivo:</label>
            <textarea class="form-control" id="motivo-abatimento" #motivoAbatimento required tooltip="No mínimo 10 caractéres"></textarea>
          </div>
        </form>
        <div class="alert alert-info" role="alert">
          Você receberá um e-mail com o retorno da sua solicitação.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onAbaterBoleto(valorAbatimento.value, motivoAbatimento.value, selectedItem)"
          [disabled]="!valorAbatimento.value || !motivoAbatimento.value || motivoAbatimento.value.length < 10"
        >
          Solicitar Abatimento
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="baixaBoletoModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="baixaBoletoModalLabel">
          Baixa de Boleto
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="documento" class="col-form-label">Documento:</label>
            <input type="text" class="form-control" id="documento" [(ngModel)]="documento"  disabled />
        </div>
        <div class="form-group">
          <label for="data-vencimento" class="col-form-label">Vencimento:</label>
          <input type="date" class="form-control" id="data-vencimento" [(ngModel)]="dataVencimento" disabled  />
        </div>
        <div class="form-group">
          <label for="valor" class="col-form-label">Valor do Boleto:</label>
          <input type="number" class="form-control" id="valor" step="0.01" [(ngModel)]="valor"  disabled />
        </div>
        <form>
          <div class="form-group">
            <label for="motivo" class="col-form-label">Motivo:</label>
            <textarea class="form-control" id="motivo-baixa" #motivoBaixa required tooltip="No mínimo 10 caractéres"></textarea>
          </div>
        </form>
        <div class="alert alert-info" role="alert">
          Você receberá um e-mail com o retorno da sua solicitação.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onBaixarBoleto(motivoBaixa.value, selectedItem)"
          [disabled]="!motivoBaixa.value || motivoBaixa.value.length < 10"
        >
          Solicitar Baixa
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="historicoBoletoModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="historicoBoletoModalLabel">
          Histórico de Boleto
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="history">
          <div class="form-group">
            <label for="documento" class="col-form-label">Documento:</label>
            <input type="text" class="form-control" id="documento" [(ngModel)]="documento" disabled />
          </div>

          <!-- Exibindo o histórico -->
          <div class="form-group">
            <label for="history" class="col-form-label">Histórico:</label>
            <ul id="history" class="list-group">
              <li *ngFor="let item of formatarHistorico(history)" class="list-group-item">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div *ngIf="!history">
          <p>Nenhum histórico disponível.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>

